if (!customElements.get('dio-expandable-desktop-nav')) {
  customElements.define(
    'dio-expandable-desktop-nav',
    class DioExpandableDesktopNav extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;

        this.toggle = this.querySelector('[data-dio-expandable-nav-toggle]');
        this.menu = this.querySelector('.dio-expandable-desktop-nav__menu');
        this.menuList = this.menu?.querySelector('.list-menu--inline');
        this.header = this.closest('.header');
        this.desktopQuery = window.matchMedia('(min-width: 990px)');
        if (!this.toggle || !this.menu || !this.menuList || !this.header) return;

        this.onToggle = this.onToggle.bind(this);
        this.onDocumentKeydown = this.onDocumentKeydown.bind(this);
        this.onDocumentClick = this.onDocumentClick.bind(this);
        this.onViewportChange = this.onViewportChange.bind(this);
        this.requestFitUpdate = this.requestFitUpdate.bind(this);

        this.toggle.addEventListener('click', this.onToggle);
        document.addEventListener('keydown', this.onDocumentKeydown);
        document.addEventListener('click', this.onDocumentClick);
        this.desktopQuery.addEventListener('change', this.onViewportChange);
        window.addEventListener('resize', this.requestFitUpdate);

        this.initialized = true;
        this.classList.add('is-ready');
        this.setOpen(false);
        this.requestFitUpdate();
        if (document.fonts?.ready) document.fonts.ready.then(this.requestFitUpdate).catch(() => {});
      }

      disconnectedCallback() {
        this.toggle?.removeEventListener('click', this.onToggle);
        document.removeEventListener('keydown', this.onDocumentKeydown);
        document.removeEventListener('click', this.onDocumentClick);
        this.desktopQuery?.removeEventListener('change', this.onViewportChange);
        window.removeEventListener('resize', this.requestFitUpdate);
        if (this.fitFrame) window.cancelAnimationFrame(this.fitFrame);
        this.header?.classList.remove('header--desktop-nav-drawer-fallback');
        this.initialized = false;
      }

      onToggle() {
        this.setOpen(!this.classList.contains('is-open'));
      }

      onDocumentKeydown(event) {
        if (event.key !== 'Escape' || event.defaultPrevented || !this.classList.contains('is-open')) return;
        event.preventDefault();
        this.setOpen(false, true);
      }

      onDocumentClick(event) {
        if (!this.classList.contains('is-open') || this.contains(event.target)) return;
        this.setOpen(false);
      }

      onViewportChange(event) {
        if (!event.matches) this.setOpen(false);
        this.requestFitUpdate();
      }

      requestFitUpdate() {
        if (!this.isConnected || this.fitFrame) return;
        this.fitFrame = window.requestAnimationFrame(() => {
          this.fitFrame = null;
          this.updateFit();
        });
      }

      updateFit() {
        this.header.classList.remove('header--desktop-nav-drawer-fallback');
        if (!this.desktopQuery.matches) return;

        const useDrawerFallback = this.menuList.scrollWidth > this.menu.clientWidth + 1;
        this.header.classList.toggle('header--desktop-nav-drawer-fallback', useDrawerFallback);
        if (useDrawerFallback) this.setOpen(false);
      }

      setOpen(open, restoreFocus = false) {
        const isOpen = Boolean(open && this.desktopQuery.matches);
        const focusWasInsideMenu = this.menu.contains(document.activeElement);
        this.classList.toggle('is-open', isOpen);
        this.toggle.setAttribute('aria-expanded', isOpen.toString());
        this.toggle.setAttribute('aria-label', isOpen ? this.toggle.dataset.closeLabel : this.toggle.dataset.openLabel);
        this.menu.toggleAttribute('inert', !isOpen);
        this.menu.setAttribute('aria-hidden', (!isOpen).toString());

        if (!isOpen) this.closeChildMenus();
        if (restoreFocus || (!isOpen && focusWasInsideMenu)) this.toggle.focus();
      }

      closeChildMenus() {
        this.menu.querySelectorAll('details[open]').forEach((details) => {
          details.open = false;
        });
      }
    }
  );
}
